import { Component, OnInit, OnDestroy, ViewChild, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { PostTradeService } from '../../post-trade.service';
import { RbGridComponent } from '../../../shared-components/rb-grid/rb-grid.component';
import { BreadcrumbComponent } from '../../../breadcrumb/breadcrumb.component';
import { AccountLinkingDetailComponent } from '../account-linking-detail/account-linking-detail.component';

@Component({
  selector: 'app-account-linking',
  templateUrl: './account-linking.component.html',
  styleUrls: ['./account-linking.component.scss'],
  imports: [
    AccountLinkingDetailComponent,
    BreadcrumbComponent,
    RbGridComponent,
  ],
})
export class AccountLinkingComponent implements OnInit, OnDestroy {
  ptSvc = inject(PostTradeService);
  private activatedRoute = inject(ActivatedRoute);
  private route = inject(Router);

  @ViewChild(RbGridComponent) rbGrid: RbGridComponent;

  unsubscribe: Subject<any> = new Subject();
  directAccountId = '';
  gridConfig = {
    title: 'Account Linking',
    gridName: 'AccountLinkingGrid',
    showGridFilters: true,
    showFilterManager: false,
    manualSearch: true,
    searchButtonText: 'Search Results',
    showBulkActions: false,
    downloadGridButton: false,
    gridActionColumn: true,
    previewActionText: 'View Account',
    showActionId: true,
    rowSelector: 'DirectAccountID',
    gridType: 'account-linking',
    detailViewRoute: '/account-linking/',
    showGridColumnFilters: true,
    getSetup: this.getGridSetup,
    getData: this.getGridData,
  };
  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade',
    },
    {
      label: 'Account Linking',
      link: 'account-linking',
    },
  ];

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params.id) {
          this.directAccountId = params.id;
          this.crumbConfig.push({
            label: this.directAccountId,
            link: `account-grouping/${this.directAccountId}`,
          });
        } else {
          this.directAccountId = '';
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  getGridSetup() {
    return this.ptSvc.getAlGridSetup();
  }

  getGridData(reqData) {
    return this.ptSvc.getAccountLinkingGridData(reqData);
  }
}
